import create from "zustand";

interface SessionObjectiveState {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useSessionObjective = create<SessionObjectiveState>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useSessionObjective;
